/**
 * Icon gauges instead of a sentence: bowl, water, appetite, plus small
 * attention flags (bath, vet, scoop, scruffy, thirsty) and the weather glyph.
 */
export interface GaugeState {
  bowl: number; // 0..1
  water: number; // 0..1
  hunger: number; // 0..1 (1 = starving)
  flags: string[];
  mood: string;
  /** days together and the glyph to show with it (🐾 normally, a holiday emoji on the day) */
  days: number;
  daysGlyph: string;
  /** credit balance */
  credits: number;
  sky: 'clear' | 'cloudy' | 'rain' | 'snow';
  night: boolean;
  temp: number | null;
}

const FLAG_ICON: Record<string, string> = { bath: '🛁', vet: '🩺', scoop: '🧹', scruffy: '🪮', thirsty: '💧' };
const SKY_ICON = { clear: '☀️', cloudy: '☁️', rain: '🌧️', snow: '❄️' };

export class Gauges {
  private el: HTMLElement;
  private last = '';
  constructor() {
    this.el = document.querySelector<HTMLElement>('#gauges')!;
  }

  private bar(icon: string, v: number, warn: boolean): string {
    const pct = Math.round(Math.max(0, Math.min(1, v)) * 100);
    return `<span class="gauge${warn ? ' warn' : ''}" title="${pct}%"><span class="gauge-icon">${icon}</span><span class="gauge-bar"><span class="gauge-fill" style="height:${pct}%"></span></span></span>`;
  }

  set(g: GaugeState): void {
    const html =
      `<span class="gauge-days" title="days together">${g.daysGlyph}<b>${g.days}d</b></span>` +
      `<span class="gauge-days gauge-credits" title="credits">🪙<b>${g.credits}</b></span>` +
      this.bar('🍖', g.bowl, g.bowl < 0.15) +
      this.bar('💧', g.water, g.water < 0.15) +
      this.bar('😋', 1 - g.hunger, g.hunger > 0.7) +
      `<span class="gauge-flag gauge-mood" title="mood">${g.mood}</span>` +
      g.flags.map((f) => `<span class="gauge-flag" title="${f}">${FLAG_ICON[f] ?? '•'}</span>`).join('') +
      `<span class="gauge-weather">${g.night ? '🌙' : SKY_ICON[g.sky]}${g.temp !== null ? ` ${Math.round(g.temp)}°` : ''}</span>`;
    if (html !== this.last) {
      this.last = html;
      this.el.innerHTML = html;
    }
  }
}
